import AnalyticsEvent from './AnalyticsEvent';
import dayjs from 'dayjs';
import { Creator } from '../Creator';


export default class AnalyticsReaderEvent extends AnalyticsEvent {
    productId: number;
    productName: string;
    seriesId: number;
    seriesName: string;
    subCategory: string;
    tags: string[];
    priceType: string;
    price: string;
    isOnSale: boolean;
    creators: Creator[];
    pageNumber: number;
    eventTag: string;

    constructor(sessionId: string, eventName: string, pathName: any, extraData: string,
                productId: number, productName: string, seriesId: number, seriesName: string,
                subCategory: string, tags: string[], priceType: string, price: string, isOnSale: boolean,
                creators: Creator[], pageNumber: number, eventTag: string, userProxy: string)
    {
        super(sessionId,eventName,pathName,extraData, userProxy);
        this.productId = productId;
        this.productName = productName;
        this.seriesId = seriesId;
        this.seriesName = seriesName;
        this.subCategory = subCategory;
        this.tags = tags;
        this.priceType = priceType;
        this.price = price;
        this.isOnSale = isOnSale;
        this.creators = creators;
        this.pageNumber = pageNumber;
        this.eventTag = eventTag;

    }
}